import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { paymentResponseHandler } from '../api/loginAPI';

const PaymentResponse = (props) => {
    const [processed, setProcessed] = useState(false);
    const [success, setSuccess] = useState(false);
    const [orderDetails, setOrderDetails] = useState(null);

    useEffect(() => {
        // Check if this is a form POST submission
        const handleFormSubmission = () => {
            // Look for the hidden form fields that might be present from the payment gateway
            // const orderIdInput = document.querySelector('input[name="order_id"]');
            // const statusInput = document.querySelector('input[name="status"]');

            const query = new URLSearchParams(location.search);
            const orderIdInput = query.get("order_id");
            const statusInput = query.get("status");

            // console.log("-----",orderIdInput,statusInput)
            
            if (orderIdInput) {
                // Extract order_id from the form and clean it (remove comma if present)
                let orderId = orderIdInput.value;
                if (orderId.includes(',')) {
                    orderId = orderId.split(',')[0];
                }
                
                const status = statusInput ? statusInput.value : null;
                // console.log('Form submission detected. Order ID:', orderId, 'Status:', status);
                
                // Process payment with the extracted data
                handlePaymentResponse({
                    orderId: orderId,
                    status: status
                });
                return true;
            }
            return false;
        };

        // First try to handle form submission
        const isFormSubmission = handleFormSubmission();
        
        // If not a form submission, try query parameters
        if (!isFormSubmission) {
            const queryParameters = new URLSearchParams(window.location.search);
            const orderId = queryParameters.get("order_id");
            
            if (orderId) {
                console.log('Query parameter detected. Order ID:', orderId);
                handlePaymentResponse({
                    orderId: orderId,
                    status: queryParameters.get("status")
                });
            } else {
                Swal.close();
                Swal.fire({
                    icon: "error",
                    titleText: "Error: Invalid Order ID",
                    text: "No order ID was found in the request",
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
            }
        }
    }, []);

    const handlePaymentResponse = async (paymentData) => {
        try {
            Swal.fire({
                titleText: 'Loading',
                text: 'Processing payment response...',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            
            // Pass all payment data to the handler, not just the orderId
            const response = await paymentResponseHandler(paymentData);
            
            setProcessed(true);
            setSuccess(response.success || response.status === 'CHARGED');
            setOrderDetails(response);
            
            Swal.close();
        } catch (err) {
            console.error('Payment processing error:', err);
            setProcessed(true);
            setSuccess(false);
            
            Swal.close();
            Swal.fire({
                icon: "error",
                titleText: "Transaction Failed",
                text: err.message || "Payment processing encountered an error",
                showConfirmButton: false,
                allowOutsideClick: false
            });
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="text-center" style={{marginTop: '15%'}}>
                        {processed && success && (
                            <h3 className="text-center">
                                <span>Payment Successful</span>
                                <p>
                                    <i className="fa fa-check-circle-o green bigger-300"
                                        style={{marginTop: '20px', fontSize: '200%', color: '#69aa46'}}
                                        aria-hidden="true"></i>
                                </p>
                                {orderDetails && (
                                    <div className="mt-3">
                                        <p>Order ID: {orderDetails.orderId || orderDetails.order_id}</p>
                                        {orderDetails.amount && (
                                            <p>Amount: {orderDetails.currency || 'INR'} {orderDetails.amount}</p>
                                        )}
                                        {orderDetails.transactionId && (
                                            <p>Transaction ID: {orderDetails.transactionId}</p>
                                        )}
                                    </div>
                                )}
                            </h3>
                        )}
                        
                        {processed && !success && (
                            <h3 className="text-center">
                                <span>Transaction Failed</span>
                                <p>
                                    <i className="fa fa-times-circle-o red bigger-300"
                                        style={{marginTop: '20px', fontSize: '200%', color: '#d9534f'}}
                                        aria-hidden="true"></i>
                                </p>
                                {orderDetails && orderDetails.message && (
                                    <p className="mt-3">{orderDetails.message}</p>
                                )}
                            </h3>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentResponse;